import { render, staticRenderFns } from "./htmlrender.vue?vue&type=template&id=5224fd42&"
import script from "./htmlrender.vue?vue&type=script&lang=js&"
export * from "./htmlrender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports